module.exports = __webpack_public_path__ + "static/media/bookmark-svgrepo-com.00361de9.svg";